export default __webpack_public_path__ + "3b3969783e21712a6e0db5f43f7fbdc3.svg";